import { render, staticRenderFns } from "./upComingTours.vue?vue&type=template&id=4c8ee3f9&scoped=true"
import script from "./upComingTours.vue?vue&type=script&lang=js"
export * from "./upComingTours.vue?vue&type=script&lang=js"
import style0 from "./upComingTours.vue?vue&type=style&index=0&id=4c8ee3f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ee3f9",
  null
  
)

export default component.exports